import Immutable from "immutable";
import { put, call } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";
import { getSchoolMoneyLocalStoreData, saveSchoolMoneyLocalStoreData } from "state/localStore";
import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { fetchActivePaymentsSucceeded } from "state/school_money/actions";

import ClubBooking from "state/school_money/entities/ClubBooking";
import DinnerBooking from "state/school_money/entities/DinnerBooking";
import OtherPayment from "state/school_money/entities/OtherPayment";
import ParentalConsentItem from "state/school_money/entities/ParentalConsentItem";

export default function* fetchActivePaymentsSaga(action) {
  const forceApiRefresh = action.payload.forceApiRefresh;
  let activePaymentData;

  if(!forceApiRefresh) {
    activePaymentData = getSchoolMoneyLocalStoreData("active_payment");
  }

  if(activePaymentData === undefined) {
    const response = yield call(sendSchoolMoneyDataRequest, "get_active_payments");
    activePaymentData = response.data.active_payments;
    saveSchoolMoneyLocalStoreData("active_payment", activePaymentData);
  }

  // collect payments by their type
  const activePaymentList = new Immutable.List( activePaymentData );
  const activePaymentsByType = activePaymentList.groupBy(payment => payment.type);

  const clubBookingList = activePaymentsByType.get("club", []);
  const clubBookingsByID = arrayToEntityMap(ClubBooking.fromAppserver, clubBooking => clubBooking.id, clubBookingList);

  const dinnerBookingList = activePaymentsByType.get("dinner", []);
  const dinnerBookingsByID = arrayToEntityMap(DinnerBooking.fromAppserver, dinnerBooking => dinnerBooking.id, dinnerBookingList);

  const otherPaymentList = activePaymentsByType.get("payment", []);
  const otherPaymentsByID = arrayToEntityMap(OtherPayment.fromAppserver, otherPayment => otherPayment.id, otherPaymentList);

  const parentalConsentItems = filterParentalConsentItems(clubBookingsByID, otherPaymentsByID)
    .map(ParentalConsentItem.fromActivePayment);

  yield put(fetchActivePaymentsSucceeded(clubBookingsByID, dinnerBookingsByID, otherPaymentsByID, parentalConsentItems));

}

function filterParentalConsentItems(clubBookings, otherPayments) {
  const filteredClubBookings = clubBookings.filter(clubBooking => clubBooking.requiresParentalConsent);
  const filteredOtherPayments = otherPayments.filter(otherPayment => otherPayment.requiresParentalConsent);
  return filteredClubBookings.concat(filteredOtherPayments);
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchActivePaymentsSaga.js